import { useMemo } from 'react';
import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const FETCH_SUBSCRIPTIONS_FIELD_NAME = 'FETCH_SUBSCRIPTIONS_FIELD_NAME';
export const FETCH_SUBSCRIPTIONS = registerQuery({
  fieldName: FETCH_SUBSCRIPTIONS_FIELD_NAME,
  args: ['formGuid'],
  fetcher({
    formGuid
  }) {
    return http.get(`/esp-sync/v1/form-subscriptions/${formGuid}`);
  }
});
export default function useFetchSubscriptions(formGuid) {
  const {
    data,
    error,
    loading
  } = useQuery(FETCH_SUBSCRIPTIONS, {
    variables: {
      formGuid
    }
  });
  return useMemo(() => ({
    data: data && Array.isArray(data[FETCH_SUBSCRIPTIONS_FIELD_NAME]) ? data[FETCH_SUBSCRIPTIONS_FIELD_NAME] : [],
    error,
    loading
  }), [data, error, loading]);
}